module.exports = __webpack_public_path__ + "img/fejlec.c90fe256.png";